import DesignTokens from '@tableau/design-tokens';
import { TabStyles } from '@tableau/widgets';
import { CSSProperties } from 'react';

import { CommonStyles } from '~src/commonInfra/styles/CommonStyles';
import { applyColor }from '~src/style/ColorService';

import { cssClass } from '../../style';

const { Colors, Sizing, Spacing, Typography } = TabStyles;

const cssPrefix = 'UserNotificationSettings';

const leftCell: CSSProperties = {
  paddingLeft: '0 !important',
};

const cell: CSSProperties = {
  verticalAlign: 'middle',
};

export const gridContainer = cssClass(cssPrefix, 'gridContainer', {
});

export const gridContainerUserSettings = cssClass(cssPrefix, 'gridContainer', {
  paddingBottom: '16px'
});

export const siteSettingsFormContainer = cssClass(cssPrefix, 'siteSettingsFormContainer', {
  marginBottom: Spacing.DefaultSpace,
});

export const headerCell = cssClass(cssPrefix, 'headerCell', {
  fontWeight: 'bold',
  padding: `0 ${CommonStyles.Sizes.MediumSpace}px 0 ${CommonStyles.Sizes.MediumSpace}px`
});

export const groupNameCell = cssClass(cssPrefix, 'groupNameCell', {
  paddingTop: '16px',
  fontWeight: 'bold',
  ...leftCell,
  ...cell,
});

export const bucketNameCell = cssClass(cssPrefix, 'bucketNameCell', {
  fontWeight: 'normal',
  ...leftCell,
  ...cell,
});

export const settingCell = cssClass(cssPrefix, 'setting', {
  textAlign: 'center',
  ...cell,
});

export const buttonCell = cssClass(cssPrefix, 'buttonCell', {
  paddingRight: '0 !important'
});

export const explanationBlock = cssClass(cssPrefix, 'explanation', {
  marginTop: Spacing.ExtraLargeSpace,
  color: applyColor(DesignTokens.color.font.default.default, Colors.F9),
});

export const pulseDisclaimerBlock = cssClass(cssPrefix, 'pulseDisclaimer', {
  marginTop: Spacing.MediumSpace,
  color: applyColor(DesignTokens.color.font.default.default, Colors.F9),
});

export const pulseDisclaimerButton = cssClass(cssPrefix, 'pulseDisclaimerButton', {
  background: 'none',
  border: 'none',
  color: applyColor(DesignTokens.color.component.content.header.default.info, '#05628A'),
  paddingLeft: TabStyles.Spacing.SmallSpace,
  font: 'inherit',
  fontWeight: 500,
  $nest: {
    '&:hover:enabled': {
      textDecoration: 'underline',
      cursor: 'pointer'
    },
  },
});